import { computed } from 'vue';
import { loadScript } from '@utils/loadScript';
import { useKillswitches } from '@modules/featureControl';
import { useExperiments } from '@composables/useExperiments';
import { useEnvProps } from '@composables/useEnvProps';

/**
 * Collects key props from dynamic sources and return them in one single data object.
*/
export function useOutfittingShopSimilar() {
  const { isMcom, isProduction } = useEnvProps();
  const { experimentFlags } = useExperiments();
  const { killswitches } = useKillswitches();

  const isExperimentEnabled = computed(() => experimentFlags.shopTheLookEnabled && killswitches.shopTheLookEnabled);

  const start = async () => {
    const shopSimilarScriptUrl = 'https://web-assets.stylitics.com/loader/latest/loader.js';
    const accountName = isMcom ? 'macys' : 'bloomingdales';
    const envName = isProduction ? 'production' : 'staging';

    if (!isExperimentEnabled.value) return;

    try {
      await loadScript(shopSimilarScriptUrl);
      const StartFunction = window.StyliticsShopSimilarWidget;

      const widgetInstance = new StartFunction(accountName, {
        api: {
          env: envName,
        },
      });

      widgetInstance.start();
    } catch (err) {
      throw new Error('Error loading Outfitting Shop Similar script');
    }
  };

  return {
    start,
  };
}

export default {
  useOutfittingShopSimilar,
};
